<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="7"
    viewBox="0 0 13 7"
    fill="none"
   data-testid="assets-icon-arrow-up-svg">
    <path
      d="M12 1L6.5 6L1 1"
      stroke="#292929"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    data-testid="assets-icon-arrow-up-path" />
  </svg>
</template>